import { render, staticRenderFns } from "./PostalCodeSurvey.vue?vue&type=template&id=4a4b84aa"
import script from "./PostalCodeSurvey.vue?vue&type=script&lang=js"
export * from "./PostalCodeSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports